import React from 'react';
import { useTranslation } from 'react-i18next';
import { trustedByLogos } from '../data/content';

const TrustedBy = () => {
  const { t } = useTranslation();
  
  return (
    <section className="trusted-section">
      <div className="trusted-container">
        <p className="trusted-label">{t('trusted.label')}</p>
        <div className="trusted-logos">
          {trustedByLogos.map((company, index) => (
            <div key={index} className="trusted-logo-item">
              <img src={company.logo} alt={company.name} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustedBy;